import { OrientationPresetKind, type IViewPortOrientation } from '@/engine/app/interfaces';
import { OrientationPreset } from '@/engine/app/models/OrientationPreset';
import type { ViewEntity } from '@/engine/app/models/viewEntity/view.entity';
import type { ICommand } from '@/engine/app/modules/core/interfaces/Command';
import { createValueAlgorithmBuilder } from '@/engine/PlanningAlgorithm/CustomMeasurementsAlgorithmBuilders';
import type { PlanningAlgorithm } from '@/engine/PlanningAlgorithm/PlanningAlgorithm';
import * as DT from '@/engine/PlanningAlgorithm/DataTypes';

export class RemoveOrientationPresetCommand implements ICommand {
  private _targetView: ViewEntity;

  private readonly _planningAlgorithm: PlanningAlgorithm;

  private readonly _descriptor: string;

  private readonly _label: string;

  private readonly _orientation: IViewPortOrientation;

  public constructor(
    view: ViewEntity,
    label: string,
    descriptor: string,
    orientation: IViewPortOrientation,
    planningAlgorithm: PlanningAlgorithm
  ) {
    this._targetView = view;
    this._planningAlgorithm = planningAlgorithm;
    this._descriptor = descriptor;
    this._label = label;
    this._orientation = orientation;
  }

  public async execute(): Promise<boolean> {
    this._targetView.deleteOrientationPreset(this._descriptor);
    await this._planningAlgorithm.dropAlgorithmExtensionAsync(this._descriptor);
    return true;
  }

  public async undo(): Promise<boolean> {
    const orientationModel = new DT.Orientation({
      top: this._orientation.topVector,
      dir: this._orientation.directionVector
    });
    await this._planningAlgorithm.extendAlgorithmAsync(
      createValueAlgorithmBuilder(this._descriptor, orientationModel),
      this._descriptor
    );
    this._targetView.addOrientationPreset(
      new OrientationPreset(this._label, this._descriptor, OrientationPresetKind.Custom)
    );
    return false;
  }
}
